import { Box, CircularProgress, makeStyles, Typography } from '@mui/material';
import * as React from 'react';

export const CircularProgressWithLabel = ({value, caption, subcaption}: {value: number, caption: string, subcaption: string}) => {
    return <Box minWidth={"fit-content"} minHeight={"fit-content"} display="inline-flex" flexDirection={"column"} alignItems="center" position={"relative"}>
        <CircularProgress variant="determinate" value={100} sx={{color: "gray", position:"absolute", minWidth: "250px", minHeight: "250px"}}/>
        <CircularProgress variant="determinate" value={value} sx={{color: "#196096", minWidth: "250px", minHeight: "250px"}}/>

        <Box sx={{position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", textAlign: "center"}}>
            <Typography fontSize={28}>{value}%</Typography>
            <Typography variant={"bold"} fontSize={14}>{caption}</Typography>
            <Typography variant={"body2"} fontSize={14}>{subcaption}</Typography>
        </Box>
    </Box>
}